import {
  SET_PACKAGE,
  SET_PACKAGE_COUNT,
  SET_PACKAGES_DATA,
} from "../types/types";

export const setPackage = (value) => {
  return {
    type: SET_PACKAGE,
    payload: { data: value },
  };
};
export const setActiveMemberSubscriptionsForDudction = (value) => {
  return {
    type: "SET_PACKAGE_FOR_DEDUCTION",
    payload: { data: value },
  };
};
export const setPackageData = (value) => {
  return {
    type: "SET_PACKAGE_DATA",
    payload: { data: value },
  };
};

export const setPackagesData = (value) => {
  return {
    type: SET_PACKAGES_DATA,
    payload: { data: value },
  };
};
export const setAppointmentTypes = (value) => {
  return {
    type: "SET_APPOINTMENT_TYPES_DATA",
    payload: { data: value },
  };
};


export const setPackageCount = (value) => {
  return {
    type: SET_PACKAGE_COUNT,
    payload: { data: value },
  };
};
export const toggleDeactivateModalOpen = () => {
  return {
    type: "TOGGLE_DEACIVATE_MODAL_OPEN",
  };
};
export const setSelectedSinglePackage = (value) => {
  return {
    type: "SET_SELECTED_SINGLE_PACKAGE",
    payload: { data: value },
  };
};
export const toggleActivateModalOpen = () => {
  return {
    type: "TOGGLE_ACTIVATE_MODAL_OPEN",
  };
};
export const toggleSetPackageToBookAllClassesModalOpen = () => {
  return {
    type: "TOGGLE_SET_PACKAGE_TO_BOOK_ALL_CLASSES_MODAL_OPEN",
  };
};
